<template>
  <div>
    <transition name="overlay-fade">
      <div class="overlay" v-if="showOverlay"></div>
    </transition>
    <div class="file-drop-area mb-3" :key="keyFormRender">
      <div class="mt-2 mb-2">
        <p>Sube tu logotipo aquí para personalizar la apariencia de tu Checkout. Este se mostrará en la parte superior
          durante el proceso de compra. </p>
        <ul class="mb-1 pt-1">
          <li>Formato de imagen permitido: [PNG].</li>
          <li>Tamaño requerido: 300px por 300px.</li>
        </ul>
      </div>
      <div class="container_company--info">
        <div>
          <img class="container_company--logo" :src="form.logo_url_v2 || IconLogoDefault" alt="Logo de la empresa" />
          <b-button variant="warning" class="p-1" @click="openFileInput" :disabled="!form.id">Subir logotipo</b-button>
        </div>
      </div>
      <input ref="fileInput" v-if="!loading.logo" type="file" @change="changeCompanyLogo" name="file-input-company"
        id="file-input-company" class="file-input invisible d-none" accept=".png, jpg" />
    </div>
    <div class="w-full d-flex justify-content-end">
      <b-button variant="warning" @click="continuar">Continuar</b-button>
    </div>
  </div>
</template>

<script>
import BaseServices from '@/store/services/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import defaultLogo from '@/assets/images/icons/company_default_grey.png'
import isEqual from 'lodash/isEqual'
export default {
  name: 'tab-logotipo-loader',
  props: ['company_data', 'setUserInSession', 'loadingInfoCompany'],
  data() {
    return {
      form: {},
      IconLogoDefault: defaultLogo,
      loading: {
        logo: false
      },
      keyFormRender: 0,
      baseService: new BaseServices(this),
      showOverlay: false
    }
  },
  computed: {
    isUserInSession() {
      return !!this.setUserInSession?.id
    }
  },
  watch: {
    setUserInSession(value) {
      if (value && value?.id) this.setRoleUsers(value)
    },
    company_data: {
      immediate: true,
      handler(val) {
        if (val && val.company) {
          this.form = { ...val.company }
        } else if (val && val.id) {
          this.form = { ...val }
        }
      }
    },
    form: {
      handler(val) {
        if (val && this.originalForm) {
          if (isEqual(this.currentForm, this.originalForm)) { this.isOriginalForm = true }
          else { this.isOriginalForm = false }
        }
      },
      deep: true
    }
  },
  methods: {
    setInitialData() {
      this.setForm()
      if (this.setUserInSession && this.setUserInSession?.id) this.setRoleUsers(this.setUserInSession)
    },
    setForm() {
      if (!!this.company_data) {
        this.form = {
          ...this.company_data.company,
          activated: this.company_data.company.activated === 1
        }
      }
    },
    changeCompanyLogo(event) {
      const file = event.target.files[0]

      if (!this.form.id) {
        this.showToastNotificationError({
          title: 'Error',
          message: 'No se encontró el ID de la empresa. No se puede subir el logo.',
          variant: 'danger',
          icon: 'warning'
        })
        return
      }
      const data = {
        name: 'changeLogo',
        params: { company_id: this.form.id },
        data: { logo: file, type: 'profile' }
      }
      this.showOverlay = true
      this.baseService
        .callUploadFileCustomParams(data.name, data.data, data.params)
        .then((response) => {
          this.form.logo_url_v2 = response.data.company.logo_url_v2
          this.keyFormRender++
          this.$newSuccess('¡Logotipo subido con éxito!', 'Ya puedes verlo reflejado en la plataforma.')
        })
        .catch((err) => {
          const dataToastNotification = {
            title: '¡Ocurrió un error al subir el logotipo!',
            message: `Inténtalo de nuevo. Si el inconveniente persiste, contacta a nuestro equipo de Support para obtener más información. ${ err.message }`,
            variant: 'danger',
            icon: 'warning'
          }
          this.showToastNotificationError(dataToastNotification)
        })
        .finally(() => {
          this.showOverlay = false
          this.loading.logo = false
        })
    },
    showToastNotificationError(dataToastNotification) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: dataToastNotification.title,
          icon: dataToastNotification.icon,
          variant: dataToastNotification.variant,
          text: dataToastNotification.message
        }
      })
    },
    openFileInput() {
      this.$refs.fileInput.click()
    },
    continuar() {
      this.$emit('continuar')
    }
  }
}
</script>

<style scoped>
.container_company--info {
  width: 100%;
  height: 208px;
  margin-left: 6rem;
}

.container_company--info div {
  display: flex;
  align-items: center;
  gap: 24px;
}

.container_company--logo {
  height: 208px;
  width: 206px;
  max-height: 208px;
  max-width: 206px;
  border-radius: 4px;
  background-color: #F5F9FA;
  border: .5px solid #DDE0E4;
}

@media (max-width: 590px) {
  .container_company--info {
    margin-left: 0;
  }
  .container_company--info div {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 16px;
  }
}
</style>